async function video(uri) {}

export default { video };
